
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { HeroContent } from "./hero/HeroContent";
import { PhoneMockup } from "./hero/PhoneMockup";
import { HeroBackground } from "./hero/HeroBackground";

const Hero = () => {
  const isMobile = useIsMobile();

  return (
    <div className="relative overflow-hidden py-16 md:py-24">
      <HeroBackground />
      
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12">
          {/* Left side content */}
          <div className="w-full md:w-7/12 max-w-2xl z-10">
            <HeroContent onOpenWaitlist={() => {}} />
          </div>
          
          {/* Right side with phone mockup */}
          <div className="w-full md:w-5/12 flex justify-end items-center relative">
            <PhoneMockup />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
